import styled from '@emotion/styled';
import { tokens, Text } from '@hotjar/hotsauce';
import { FilterKindEnum } from '../../../domains/global-filters/model/FilterChain';
import type {
  SingleFilterState,
  UpsellType,
  UserAttributeSingleFilterState,
} from '../../../domains/global-filters/model/FilterChain';
import { UserAttributeMenuButton } from './UserAttributeMenuButton';
import { GenericMenuButton } from './GenericMenuButton';

const TextTitle = styled(Text)`
  padding: 0 0 ${tokens.spacer.x0} ${tokens.spacer.x2};
`;

const Container = styled.div`
  display: inline-flex;
  flex-direction: column;
  padding-bottom: ${tokens.spacer.x2};
  width: 100%;
`;

interface FilterCategoryProps {
  name: string;
  filterStateList?: SingleFilterState[];
  onNewFilter: (kind: FilterKindEnum) => void;
  onUpsellClicked?: (upsellType: UpsellType) => void;
  isMaxReached: boolean;
}

export const FilterCategory = ({
  name,
  filterStateList,
  onNewFilter,
  onUpsellClicked,
  isMaxReached,
}: FilterCategoryProps): JSX.Element | null => {
  if (!filterStateList || filterStateList.length === 0) {
    return null;
  }
  return (
    <Container>
      <div>
        <TextTitle textType="subtitle3" textColor="text_disabled">
          {name}
        </TextTitle>
      </div>
      {filterStateList.map((item) =>
        item.kind === FilterKindEnum.UserAttribute ? (
          <UserAttributeMenuButton
            filterState={item as UserAttributeSingleFilterState}
            isMaxReached={isMaxReached}
            onNewFilter={onNewFilter}
            onUpsellClicked={onUpsellClicked}
            key={item.kind}
          />
        ) : (
          <GenericMenuButton
            filterState={item}
            isMaxReached={isMaxReached}
            onNewFilter={onNewFilter}
            onUpsellClicked={onUpsellClicked}
            key={item.kind}
          />
        ),
      )}
    </Container>
  );
};
